<template>
	<div class="ol-sm-12 col-lg-2" :class="{'close-filter': openFilters !== 'narrow'}">
		<div class="filter__wrapper" :class="{open: 'letter' === showList, close: 'letter' !== showList}">
			<input type="text"
				   :placeholder="$t('filters.letter')"
				   class="filter"
				   :class="{open: 'letter' === showList, close: 'letter' !== showList}"
				   @click="updateShowList('letter')"
				   @input="showList = 'letter'"
				   v-model="searchByLetter"
			>
			<ul v-show="'letter' === showList"
				class="filter__list"
			>
				<li class="filter__list-item" @click="removeLetters">{{$t('filters.remove')}}</li>
				<li v-for="item in lettersList"
					class="filter__list-item"
					:class="{'filter__list-item--active': $store.getters.isLetterActive(item.name)}"
					@click="selectLetter(item)"
				>
					{{item.name}}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapMutations } from 'vuex'

	export default {
		props: ['openFilters'],
		data () {
			return {
				showList: '',
				searchByLetter: '',
				alphabetic: {
					name: 'Alphabetic letter',
					value: 'alphabetic',
					items: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(letter => ({
						filter: 'alphabetic',
						name: letter,
						value: letter.toLowerCase(),
						active: false
					}))
				}
			}
		},
		methods: {
			...mapActions(['fetchJudges']),
			...mapMutations(['addLetter']),
			...mapMutations(['removeLetter']),
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			},
			selectLetter (letter) {
				this.addLetter(letter.name)
				this.fetchJudges()
				this.showList = ''
			},
			removeLetters () {
				this.removeLetter()
				this.fetchJudges()
				this.showList = ''
			}
		},
		computed: {
			lettersList () {
				const inputTest = person => {
					const regExp = new RegExp('^' + this.searchByLetter, 'i')
					return regExp.test(person.name)
				}
				return this.alphabetic.items.filter(inputTest)
			}
		},
		created () {
			window.addEventListener('click', this.closeFlitersLists)
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";
</style>



// WEBPACK FOOTER //
// src/components/JudgesList/Filters/AlphabeticFilterComponent.vue